export const getAgeFromDateOfBirth = dateOfBirth =>
  dateOfBirth
    ? Math.floor(
        (Date.now() - dateOfBirth) / 1000 / 60 / 60 / 24 / 365
      ).toString()
    : '';
